<template>
  <ServiceScreenLayout :parts="parts">
    <template v-slot:call>
      <div class="row">
        <div class="col-md-8">
          <div class="card-header">
              <h4>Call Cabinet</h4>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <label>Description</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="saleDefinition.sale.callvault.description"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <label>Package</label>
                <div class="input-group">
                  <v-select
                    name="package"
                    placeholder="No Package Selected"
                    v-model="recordingSelected"
                    :options="recordingList"
                    :disabled="isDisabled"
                  >
                  </v-select>
                </div>
              </div>
            </div>
            <div class="form-row row-spacing justify-content-between" v-allowed:view="['STAFF']">
              <div class="form-group row-spacing col-auto">
                <button
                  type="button"
                  @click="saveRecordingPackage()"
                  class="btn btn-success"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ServiceScreenLayout>
</template>

<script>
import ServiceScreenLayout from "@/layouts/ServiceScreenLayout";
import SaleFunctions from "@/pages/Services/SaleFunctions";

export default {
  extends: SaleFunctions,
  components: {
    ServiceScreenLayout,
  },
  computed: {
    isDisabled() {
      return (!this.userContainsPermission(['STAFF']) && this.productAccessRestricted)
    }
  },
  data() {
    return {
      saleNumber: null,
      parts: [
        {
          name: "call",
          icon: "fa fa-phone",
          displayName: "Call Cabinet",
          permissions: ["*"],
        },
      ],
      saleDefinition: {
        sale: {
          callvault: {

          }
        },
        meta: {
          callvault: {
            children: {
              recordingPackage: {
                partMeta: {
                  options: []
                }
              }
            }
          }
        },
      },
      recordingList: [],
      recordingSelected: '',
      callsValue: 0,
      productAccessRestricted: null,
      readOnly: {},
      fullAccess: {},
    };
  },
  mounted() {
    this.saleNumber = this.$route.params.saleNumber;
    this.fetchSaleDefinition(this.saleNumber).then(
      (success) => {
        this.applySaleDefinition(success.data);
      },
      (error) => {
        console.error(error);
        this.showError("Error Fetching Sale Definition", error);
      }
    );
  },
  methods: {
    applySaleDefinition(saleDefinition) {
      this.saleDefinition = saleDefinition;
      this.productAccessRestricted = this.saleDefinition.sale.product.clientAccessRestriction === this.readOnly.description ? true : false;
      
      this.recordingSelected = this.saleDefinition.sale.callvault && this.saleDefinition.sale.callvault.recordingPackage
        ? this.saleDefinition.sale.callvault.recordingPackage.description
        : "";
      this.recordingList = this.saleDefinition.meta.callvault.children.recordingPackage.partMeta.options.map((option) => option.description);
    },
    loadSaleDefinition() {
      this.fetchSaleDefinition(this.saleNumber).then(
        (success) => {
          this.applySaleDefinition(success.data);
        },
        (error) => {
          console.error(error);
          this.showError("Error Fetching Sale Definition", error);
        }
      );
      return Promise.resolve('Success');
    },
    getProductRestrictions: function() {
      const hostUrl = this.$config.aimsAPI;

      this.$http.get(`${hostUrl}products/restrictions`).then(
        (response) => {
          const accessRestrictions = response.data;
          this.readOnly = accessRestrictions.find((access) => access.name === 'CLIENT_READONLY');
          this.fullAccess = accessRestrictions.find((access) => access.name === 'CLIENT_USAGE');          
        },
        (error) => {
          console.error(error);
          this.showError("Error fetching product restrictions", error)
        }
      )
    },
    saveSaleDefinition: function() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$http
            .put(
              this.$config.aimsAPIv2 +
                "sales/definition/" +
                this.saleDefinition.sale.saleNumber +
                "/update",
              this.saleDefinition
            )
            .then(
              (response) => {
                this.showSuccess("Save Success");
                this.loadSaleDefinition();
              },
              (error) => {
                console.error(error);
                this.showError("Error Saving Voice Service", error);
              }
            );
        }
      });
    },
    findPackageOption(options, selectedDescription) {
      return options.find((option) => option.description === selectedDescription);
    },
    saveRecordingPackage() {
      const selectedPackage = this.findPackageOption(
        this.saleDefinition.meta.callvault.children.recordingPackage.partMeta.options,
        this.recordingSelected
      );

      if (!selectedPackage) {
        return;
      }

      this.saleDefinition.sale.callvault.callCabinetPackageNumber = selectedPackage.callCabinetPackageNumber;

      this.saveSaleDefinition();
    },
    removeRecordingPackage() {
      if (!this.saleDefinition.sale.callvault || !this.saleDefinition.sale.callvault.recordingPackage) {
        return;
      }

      return this.$swal({
        title: "Are you sure you want to remove this package?",
        text: this.saleDefinition.sale.callvault.recordingPackage.description,
        type: "warning",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Remove",
      }).then((result) => {
        if (result.value) {
          this.deleteObjPart(this.saleDefinition.sale.callvault).then(
            () => {
              this.showSuccess("Package Removed Successfully");
              this.recordingSelected = "";
              this.loadSaleDefinition();
            },
            (error) => {
              console.error(error);
              this.showError("Error Removing Call Cabinet Package", error);
            }
          );
        }
      });
    },
  },
};
</script>